import { cn } from "design-system/utils"
import { useTranslation } from "react-i18next"
import { ClusterDomain } from "schema"

type Props<T extends ClusterDomain> = {
  value: T
  options: T[]
  onChange: (value: T) => void
  className?: string
}

export function DomainSelector<T extends ClusterDomain>({
  value,
  options,
  onChange,
  className,
}: Props<T>) {
  const { t } = useTranslation()

  if (options.length < 2) return null

  return (
    <div
      className={cn(
        "inline-flex rounded-md border border-input bg-background overflow-x-auto overflow-y-hidden divide-x divide-input h-10 max-w-full",
        className,
      )}
    >
      {options.map((opt) => {
        const isActive = value === opt

        return (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={cn(
              "w-full cursor-pointer px-3 py-1.5 text-xs whitespace-nowrap",
              "transition-colors focus-visible:outline-hidden focus-visible:ring focus-visible:ring-ring",
              isActive
                ? "bg-muted text-foreground font-medium"
                : "text-muted-foreground hover:bg-muted/40",
            )}
          >
            {t(`dashboard.domains.${opt}`)}
          </button>
        )
      })}
    </div>
  )
}
